<template>
    <div class="flex items-center select-none">

        <div class="mr-6 font-semibold">
            Search by
        </div>
        <input
            type="search"
            placeholder="Search..."
            @input="handleInputChange($event.target.value)"
            @search="handleSearchClear($event.target.value)"
        >

    </div>
</template>

<script>
import debounce from 'debounce';

export default {

    methods: {
        handleInputChange: debounce(function _(val) {
            this.$emit('input', val.trim());
        }, 500),
        /**
         * This handles users clicking the HTML5 search input clear button.
         * Since it also fires when "searching" (hitting enter), we only trigger
         * the handleInputChange method if there's no value.
         */
        handleSearchClear(val) {
            val || this.handleInputChange('');
        },
    },

};
</script>

<style lang="scss" scoped>
input {
    @apply border border-2 border-primary rounded-full px-4 h-10 flex items-center text-sm font-semibold text-primary;
}
</style>
